export const getFooterLinks = (isLoggedIn: boolean) => {
  return [
    {
      title: 'Company',
      children: [
        {
          title: 'What we offer',
          link: '/#services',
        },
        {
          title: 'Real Estate Market',
          link: isLoggedIn ? '/portal/real-estate' : '/market',
        },
        {
          title: 'Project Slots',
          link: isLoggedIn ? '/portal/project-slots' : '/project-slots',
        },
      ],
    },
    {
      title: 'Quicklinks',
      children: [
        {
          title: 'Terms and Conditions',
          link: isLoggedIn ? '/app/terms' : '/terms',
        },
        {
          title: 'About Us',
          link: isLoggedIn ? '/app/about' : '/about',
        },
        {
          title: 'Privacy Policy',
          link: isLoggedIn ? '/app/privacy-policy' : '/privacy-policy',
        },
        {
          title: 'Blog',
          link: isLoggedIn ? '/app/blog' : '/blog',
        },
      ],
    },
  ];
};

export const contactDetails = {
  title: 'Contact Us',
  details: [
    {
      detail: 'Tel',
      value: '+2347037843246, +234907393069',
    },
    {
      detail: 'Email',
      value: 'info@awapinvestors.com',
    },
    {
      detail: 'Address',
      value: '18 brackenbury, Abakaliki, Ebonyi State, Nigeria',
    },
  ],
};
